import {Transaction} from './transaction';


export class Statement {
    public financialTransactions: Transaction[];
    public otherTransactions: Transaction[];
}


export interface StatementLineDto {
  metaId: number;
  currentStatus: ETransactionStatus;

  createDate: Date;
  authDate: Date|null;
  settleDate: Date|null;
  reversalDate: Date|null;
  avlBal: number;
  blkAmt: number;

  merchName: string;
  merchCountry: string;

  txnAmt: number;
  billAmt: number;
  settleAmt: number;

  txnCcy: number;
  billCcy: number;
  settleCcy: number;

  firstTxnDate?: Date|null;
  lastTxnDate?: Date|null;

  transactions: StatementLineTxnDto[];
  description: string;
  feeFixed?: number;
  feeRate?: number;
  fxFeeFixed?: number;
  fxFeeRate?: number;
  isCredit: boolean;
  mccCode?: number;
  procCode: string;
  gpsPosData: string;

  enrichment: StatementLineEnrichmentDto;
}

export interface StatementLineTxnDto {
  avlBal: number;
  blkAmt: number;
  txnCcy: number;
  billCcy: number;
  settleCcy: number;

  feeFixed: number;
  feeRate: number;

  fxPad: number;
  fxFeeFixed: number;
  fxFeeRate: number;
  txnType: string;
  txnStatCode: string;
  txnAmt: number;
  reasonId?: number;
  note: string;
  authType: string;
  procCode: string;
  gpsPosData: string;
  txnDate: Date;
}

export interface StatementLineEnrichmentDto {
  logoUrl: string;
  cleanName: string;
  category: string;
  brandId: string;
  locationLon?: number;
  locationLat?: number;
  city: string;
  postCode: string;
  country: string;
  website: string;
  googlePlacesId: string;
}

export enum ETransactionStatus {
  Unknown = 0,

  Authorized = 1,
  Settled = 2,
  Reversed = 3,
  Declined = 4,
  Chargeback = 5,
  AuthorizationReversed = 6,
  ChargebackReversed = 7,

  Other = 99,
}
